export const getWindow = () => {
  return window;
};
